<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Permissions des groupes
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" block class="custom-btn white--text"
                         color="#009688"
                         height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Création groupe</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-stepper v-model="e6" vertical>
                            <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                              Nom groupe de permissions
                            </v-stepper-step>
                            <v-stepper-content step="1">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="9" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Nom du groupe"
                                                    v-model="editedItem.groupName">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 2" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 2" :editable="true" step="2">
                              Compte agent principal
                            </v-stepper-step>
                            <v-stepper-content step="2">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="accountAgentRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="accountAgentWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="accountAgentDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 3" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 3" :editable="true" step="3">
                              Compte agent détaillé
                            </v-stepper-step>
                            <v-stepper-content step="3">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="accountDetailRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="accountDetailWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="accountDetailDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 4" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 4" :editable="true" step="4">
                              Pointage
                            </v-stepper-step>
                            <v-stepper-content step="4">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="timetrackingRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="timetrackingWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="timetrackingDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 5" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 5" :editable="true" step="5">
                              Planning presence
                            </v-stepper-step>
                            <v-stepper-content step="5">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="planningPresenceRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="planningPresenceWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="planningPresenceDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 6" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 6" :editable="true" step="6">
                              Planning absence
                            </v-stepper-step>
                            <v-stepper-content step="6">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="planningAbsenceRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="planningAbsenceWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="planningAbsenceDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 7" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 7" :editable="true" step="7">
                              Planning brigade
                            </v-stepper-step>
                            <v-stepper-content step="7">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="planningBrigadeRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="planningBrigadeWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="planningBrigadeDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 8" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 8" :editable="true" step="8">
                              Modifications
                            </v-stepper-step>
                            <v-stepper-content step="8">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Modif par journée"
                                          v-model="bGroupe"
                                          value="provisionalModifsExecution"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Modif par période"
                                          v-model="bGroupe"
                                          value="permanentModifsExecution"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 9" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 9" :editable="true" step="9">
                              Shift personnnalisé
                            </v-stepper-step>
                            <v-stepper-content step="9">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="personalizedShiftRead"
                                      ></v-switch>
                                    </v-col>

                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="personalizedShiftWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="personalizedShiftDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 10" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 10" :editable="true" step="10">
                              Constantes
                            </v-stepper-step>
                            <v-stepper-content step="10">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="initialConstantRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="initialConstantWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="initialConstantDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 11" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 11" :editable="true" step="11">
                              Paramétrage groupe
                            </v-stepper-step>
                            <v-stepper-content step="11">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="groupSettingsRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="groupSettingsWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="groupSettingsDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 12" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 12" :editable="true" step="12">
                              Paramétrage agent
                            </v-stepper-step>
                            <v-stepper-content step="12">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="agentSettingsRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="agentSSettingsWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="agentSSettingsDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 13" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 13" :editable="true" step="13">
                              Poste
                            </v-stepper-step>
                            <v-stepper-content step="13">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="postsRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="postsWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="postsDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 14" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 14" :editable="true" step="14">
                              Règle
                            </v-stepper-step>
                            <v-stepper-content step="14">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="rulesRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="rulesWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="rulesDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 15" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 15" :editable="true" step="15">
                              Dispatching
                            </v-stepper-step>
                            <v-stepper-content step="15">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="dispatchingsRead"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Écriture"
                                          v-model="bGroupe"
                                          value="dispatchingsWrite"
                                      ></v-switch>
                                    </v-col>
                                    <v-col>
                                      <v-switch
                                          label="Suppression"
                                          v-model="bGroupe"
                                          value="dispatchingsDelete"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 15" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 16" :editable="true" step="16">
                              Rapport Général
                            </v-stepper-step>
                            <v-stepper-content step="16">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col>
                                      <v-switch
                                          label="Lecture"
                                          v-model="bGroupe"
                                          value="dispatchingsGlobalReports"
                                      ></v-switch>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 16" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                          </v-stepper>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer groupe
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "permissions_group",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      bGroupe: [],
      dialogTmp: false,
      files: [],
      lastHighlitedRow: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      menustartWorkingDate: false,
      toObject: [],
      editedItem: {
        id: "",
        groupName: ""
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      genre: ["Homme", "Femme"],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },

        colHeaders: [
          "Id", "Nom groupe",
          "Agent lecture", "Agent écriture", "Agent suppression",
          "Détails agent lecture", "Détails agent écriture", "Détails agent suppression",
          "Pointage lecture", "Pointage écriture", "Pointage suppression",
          "Planning présence lecture", "Planning présence écriture", "Planning présence suppression",
          "Planning absence lecture", "Planning absence écriture", "Planning absence suppression",
          "Planning brigade lecture", "Planning brigade écriture", "Planning brigade suppression",
          "Modif journée exécution", "Modif période exécution",
          "Shift personnalisé lecture", "Shift personnalisé écriture", "Shift personnalisé suppression",
          "Constantes lecture", "Constantes écriture", "Constantes suppression",
          "Permissions agent lecture", "Permissions agent écriture", "Permissions agent suppression",
          "Permissions groupe lecture", "Permissions groupe écriture", "Permissions groupe suppression",
          "Poste lecture", "Poste écriture", "Poste suppression",
          "Règle lecture", "Règle écriture", "Règle suppression",
          "Dispatching lecture", "Dispatching écriture", "Dispatching suppression",
          "Rapport global lecture",
          "Date création"
        ],

        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Nom groupe", width: "150px"},
          {title: "Agent lecture", width: "200px", type: "checkbox"},
          {title: "Agent écriture", width: "200px", type: "checkbox"},
          {title: "Agent suppression", width: "250px", type: "checkbox"},
          {title: "Détails agent lecture", width: "250px", type: "checkbox"},
          {title: "Détails agent écriture", width: "250px", type: "checkbox"},
          {title: "Détails agent suppression", width: "250px", type: "checkbox"},
          {title: "Pointage lecture", width: "250px", type: "checkbox"},
          {title: "Pointage écriture", width: "250px", type: "checkbox"},
          {title: "Pointage suppression", width: "250px", type: "checkbox"},
          {title: "Planning présence lecture", width: "250px", type: "checkbox"},
          {title: "Planning présence écriture", width: "250px", type: "checkbox"},
          {title: "Planning présence suppression", width: "250px", type: "checkbox"},
          {title: "Planning absence lecture", width: "250px", type: "checkbox"},
          {title: "Planning absence écriture", width: "250px", type: "checkbox"},
          {title: "Planning absence suppression", width: "250px", type: "checkbox"},
          {title: "Planning brigade lecture", width: "250px", type: "checkbox"},
          {title: "Planning brigade écriture", width: "250px", type: "checkbox"},
          {title: "Planning brigade suppression", width: "250px", type: "checkbox"},
          {title: "Modif journée exécution", width: "250px", type: "checkbox"},
          {title: "Modif période exécution", width: "250px", type: "checkbox"},
          {title: "Shift personnalisé lecture", width: "250px", type: "checkbox"},
          {title: "Shift personnalisé écriture", width: "250px", type: "checkbox"},
          {title: "Shift personnalisé suppression", width: "250px", type: "checkbox"},
          {title: "Constantes lecture", width: "250px", type: "checkbox"},
          {title: "Constantes écriture", width: "250px", type: "checkbox"},
          {title: "Constantes suppression", width: "250px", type: "checkbox"},
          {title: "Permissions agent lecture", width: "250px", type: "checkbox"},
          {title: "Permissions agent écriture", width: "250px", type: "checkbox"},
          {title: "Permissions agent suppression", width: "250px", type: "checkbox"},
          {title: "Permissions groupe lecture", width: "250px", type: "checkbox"},
          {title: "Permissions groupe écriture", width: "250px", type: "checkbox"},
          {title: "Permissions groupe suppression", width: "250px", type: "checkbox"},
          {title: "Poste lecture", width: "250px", type: "checkbox"},
          {title: "Poste écriture", width: "250px", type: "checkbox"},
          {title: "Poste suppression", width: "250px", type: "checkbox"},
          {title: "Règle lecture", width: "250px", type: "checkbox"},
          {title: "Règle écriture", width: "250px", type: "checkbox"},
          {title: "Règle suppression", width: "250px", type: "checkbox"},
          {title: "Dispatching lecture", width: "250px", type: "checkbox"},
          {title: "Dispatching écriture", width: "250px", type: "checkbox"},
          {title: "Dispatching suppression", width: "250px", type: "checkbox"},
          {title: "Rapport global lecture", width: "250px", type: "checkbox"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ]
      }
    }
  },
  created() {
    this.getData()
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.groupName !== ""
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    },
  },
  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/profilsgroup/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["groupName"],
                item["accountAgentRead"],
                item["accountAgentWrite"],
                item["accountAgentDelete"],
                item["accountDetailRead"],
                item["accountDetailWrite"],
                item["accountDetailDelete"],
                item["timetrackingRead"],
                item["timetrackingWrite"],
                item["timetrackingDelete"],
                item["planningPresenceRead"],
                item["planningPresenceWrite"],
                item["planningPresenceDelete"],
                item["planningAbsenceRead"],
                item["planningAbsenceWrite"],
                item["planningAbsenceDelete"],
                item["planningBrigadeRead"],
                item["planningBrigadeWrite"],
                item["planningBrigadeDelete"],
                item["provisionalModifsExecution"],
                item["permanentModifsExecution"],
                item["personalizedShiftRead"],
                item["personalizedShiftWrite"],
                item["personalizedShiftDelete"],
                item["initialConstantRead"],
                item["initialConstantWrite"],
                item["initialConstantDelete"],
                item["groupSettingsRead"],
                item["groupSettingsWrite"],
                item["groupSettingsDelete"],
                item["agentSettingsRead"],
                item["agentSettingsWrite"],
                item["agentSettingsDelete"],
                item["postsRead"],
                item["postsWrite"],
                item["postsDelete"],
                item["rulesRead"],
                item["rulesWrite"],
                item["rulesDelete"],
                item["dispatchingsRead"],
                item["dispatchingsWrite"],
                item["dispatchingsDelete"],
                item["dispatchingsGlobalReports"],
                this.datefull(item["creationDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.initEditedItem();
      this.bGroupe = [];
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de la permission du groupe.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.initEditedItem();
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              newObj = {
                "id": obj[0],
                "groupName": obj[1],
                "accountAgentRead": obj[2],
                "accountAgentWrite": obj[3],
                "accountAgentDelete": obj[4],
                "accountDetailRead": obj[5],
                "accountDetailWrite": obj[6],
                "accountDetailDelete": obj[7],
                "timetrackingRead": obj[8],
                "timetrackingWrite": obj[9],
                "timetrackingDelete": obj[10],
                "planningPresenceRead": obj[11],
                "planningPresenceWrite": obj[12],
                "planningPresenceDelete": obj[13],
                "planningAbsenceRead": obj[14],
                "planningAbsenceWrite": obj[15],
                "planningAbsenceDelete": obj[16],
                "planningBrigadeRead": obj[17],
                "planningBrigadeWrite": obj[18],
                "planningBrigadeDelete": obj[19],
                "provisionalModifsExecution": obj[20],
                "permanentModifsExecution": obj[21],
                "personalizedShiftRead": obj[22],
                "personalizedShiftWrite": obj[23],
                "personalizedShiftDelete": obj[24],
                "initialConstantRead": obj[25],
                "initialConstantWrite": obj[26],
                "initialConstantDelete": obj[27],
                "groupSettingsRead": obj[28],
                "groupSettingsWrite": obj[29],
                "groupSettingsDelete": obj[30],
                "agentSettingsRead": obj[31],
                "agentSettingsWrite": obj[32],
                "agentSettingsDelete": obj[33],
                "postsRead": obj[34],
                "postsWrite": obj[35],
                "postsDelete": obj[36],
                "rulesRead": obj[37],
                "rulesWrite": obj[38],
                "rulesDelete": obj[39],
                "dispatchingsRead": obj[40],
                "dispatchingsWrite": obj[41],
                "dispatchingsDelete": obj[42],
                "dispatchingsGlobalReports": obj[43],
                "revisedUser": sessionStorage.getItem("userId")
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/profilgroup/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.getData()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la permission du groupe.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/profilgroup/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 44, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 44, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 44, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 44, "readOnly", true);
          });
    },
    initEditedItem() {
      this.editedItem.groupName = "";
      this.bGroupe = [];
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    creer() {
      this.loading = true
      const dataToSave = {
        groupName: this.editedItem.groupName,
        accountAgentRead: this.bGroupe.includes("accountAgentRead"),
        accountAgentWrite: this.bGroupe.includes("accountAgentWrite"),
        accountAgentDelete: this.bGroupe.includes("accountAgentDelete"),
        accountDetailRead: this.bGroupe.includes("accountDetailRead"),
        accountDetailWrite: this.bGroupe.includes("accountDetailWrite"),
        accountDetailDelete: this.bGroupe.includes("accountDetailDelete"),
        timetrackingRead: this.bGroupe.includes("timetrackingRead"),
        timetrackingWrite: this.bGroupe.includes("timetrackingWrite"),
        timetrackingDelete: this.bGroupe.includes("timetrackingDelete"),
        planningPresenceRead: this.bGroupe.includes("planningPresenceRead"),
        planningPresenceWrite: this.bGroupe.includes("planningPresenceWrite"),
        planningPresenceDelete: this.bGroupe.includes("planningPresenceDelete"),
        planningAbsenceRead: this.bGroupe.includes("planningAbsenceRead"),
        planningAbsenceWrite: this.bGroupe.includes("planningAbsenceWrite"),
        planningAbsenceDelete: this.bGroupe.includes("planningAbsenceDelete"),
        planningBrigadeRead: this.bGroupe.includes("planningBrigadeRead"),
        planningBrigadeWrite: this.bGroupe.includes("planningBrigadeWrite"),
        planningBrigadeDelete: this.bGroupe.includes("planningBrigadeDelete"),
        provisionalModifsExecution: this.bGroupe.includes("provisionalModifsExecution"),
        permanentModifsExecution: this.bGroupe.includes("permanentModifsExecution"),
        personalizedShiftRead: this.bGroupe.includes("personalizedShiftRead"),
        personalizedShiftWrite: this.bGroupe.includes("personalizedShiftWrite"),
        personalizedShiftDelete: this.bGroupe.includes("personalizedShiftDelete"),
        permanentShiftRead: this.bGroupe.includes("permanentShiftRead"),
        permanentShiftWrite: this.bGroupe.includes("permanentShiftWrite"),
        permanentShiftDelete: this.bGroupe.includes("permanentShiftDelete"),
        groupSettingsRead: this.bGroupe.includes("groupSettingsRead"),
        groupSettingsWrite: this.bGroupe.includes("groupSettingsWrite"),
        groupSettingsDelete: this.bGroupe.includes("groupSettingsDelete"),
        agentSettingsRead: this.bGroupe.includes("agentSettingsRead"),
        agentSettingsWrite: this.bGroupe.includes("agentSettingsWrite"),
        agentSettingsDelete: this.bGroupe.includes("agentSettingsDelete"),
        postsRead: this.bGroupe.includes("postsRead"),
        postsWrite: this.bGroupe.includes("postsWrite"),
        postsDelete: this.bGroupe.includes("postsDelete"),
        rulesRead: this.bGroupe.includes("rulesRead"),
        rulesWrite: this.bGroupe.includes("rulesWrite"),
        rulesDelete: this.bGroupe.includes("rulesDelete"),
        dispatchingsRead: this.bGroupe.includes("dispatchingsRead"),
        dispatchingsWrite: this.bGroupe.includes("dispatchingsWrite"),
        dispatchingsDelete: this.bGroupe.includes("dispatchingsDelete"),
        dispatchingsGlobalReports: this.bGroupe.includes("dispatchingsGlobalReports"),
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/profilgroup/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              this.getData()
              this.showAlert('info')
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>